import classes from './EventBannerPage.module.css';
import YuJaButton from "../../components/standardization/YuJaButton";
import EventBannerSearchForm from "./EventBannerSearchForm";
import React, {useEffect, useState} from "react";
import Skeleton from "react-loading-skeleton";
import EventBannerDetail from "./EventBannerDetail";
import {ALL_ROLES, DELETE_TEXT, EDIT_TEXT, ROLES, YUJA_INST_CODE} from "../../utils/constants";
import {InstitutionApiCalls} from "../../apis/InstitutionApiCalls";
import {useCSMAccessCheck} from "../../hooks/useCSMAccessCheck";
import {getFormatedLocalDate} from "../../utils/helpers";
import {ReactComponent as CLOCK} from "./images/clock_purple.svg";
import {ReactComponent as CLOCK_GRAY} from "./images/clock_gray.svg";
import {YuJaKebabMenuNew} from "../../components/standardization/YuJaKebabMenuNew";
import { ReactComponent as NO_BANNER } from "./images/no_banner_event_found.svg";
import YuJaDialog from "../../components/standardization/YuJaDialog";
import NormalPagination from "../../components/pagination/NormalPagination";

export const EVENT_BANNER_PAGE_VIEW_TYPES = {LIST: "LIST", CREATE: "CREATE", EDIT: "EDIT", PREVIEW: "PREVIEW"};
export const EVENT_BANNER_LOCATION_TYPES = {
    ALL: {value: "ALL", label: "All Institutions"},
    SELECTION: {value: "SELECTION", label: "Select Institutions"}
};

export default function EventBannerManagementPage({setPageIdentifier}) {
    const {loadInstitutions, listEventBanners, deleteEventBanner} = InstitutionApiCalls();
    const {checkInstAccess} = useCSMAccessCheck();


    const [filter, setFilter] = useState({});
    const [pageIndex, setPageIndex] = useState(0);
    const [pageCount, setPageCount] = useState(0)
    const [isLoading, setIsLoading] = useState(true);

    const [view, setView] = useState(EVENT_BANNER_PAGE_VIEW_TYPES.LIST);

    const [selectedBannerEvent, setSelectedBannerEvent] = useState({});

    const [institutions, setInstitutions] = useState([]);
    const [rawData, setRawData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [paginatedData, setPaginatedData] = useState([]);
    const [isFilterEmpty, setIsFilterEmpty] = useState(true);
    const [isConfirmationOpened, setIsConfirmationOpened] = useState(false);
    const [preSelectBanner, setPreSelectBanner] = useState({});

    const PAGE_SIZE = 8;


    const handleSubmit = ({...filterObj}) => {
        setFilter(filterObj);
        setPageIndex(0);
    };


    useEffect(() => {
        setPageIdentifier("Event Banner");
    }, []);

    useEffect(() => {
        if (view === EVENT_BANNER_PAGE_VIEW_TYPES.LIST) {
            setFilter({});
            loadData();
        }
    }, [view]);


    useEffect(() => {
        filterData(rawData);
    }, [filter]);

    useEffect(() => {
        let startIndex = pageIndex * PAGE_SIZE;
        setPaginatedData(filteredData.slice(startIndex, startIndex + PAGE_SIZE));
        setPageCount(Math.ceil(filteredData.length / PAGE_SIZE));
    }, [filteredData, pageIndex]);

    const filterData = (data) => {
        let copy = JSON.parse(JSON.stringify(data));
        let activeBanners = copy.filter(b => !b.isPast);
        if (!filter.keyword && (!filter.role || !filter.role.length) && !filter.startDate && !filter.endDate) {//filter is empty
            setIsFilterEmpty(true);
            copy = activeBanners;
        } else {
            setIsFilterEmpty(false);
            copy = copy.filter(banner => {
                if (!!filter.keyword && !banner.description.toLowerCase().includes(filter.keyword.toLowerCase()) ) {
                    return false;
                }

                if (!!filter.startDate && banner.startDate < filter.startDate) {
                    return false;
                }


                if (!!filter.endDate && banner.endDate > filter.endDate) {
                    return false;
                }

                if (!!filter.role && !!filter.role.length) {
                    const valueArr = filter.role.map(label => {
                        const role = Object.values(ROLES).find(r => r.display === label);
                        return role ? role.value : label;
                    })


                    if (!valueArr.includes(ALL_ROLES) && !banner.roles.includes(ALL_ROLES)) {
                        return banner.roles.some(id => valueArr.includes(id));
                    }

                }


                return true;

            });
        }
        setFilteredData(copy);
    }



    const canPreviousPage = () => pageIndex > 0;
    const canNextPage = () => pageIndex < pageCount - 1;

    const previousPage = () => setPageIndex(pageIndex - 1);
    const nextPage = () => setPageIndex(pageIndex + 1);
    const gotoPage = (index) => setPageIndex(index);
    const pageOptions = () => Array.from({ length: pageCount }, (_, i) => i);


    const loadData = () => {
        let promises = [];
        promises.push(loadInst());
        promises.push(listEventBanners())
        setIsLoading(true);
        Promise.all(promises).then(([res1, res2]) => {
            setInstitutions(res1);
            let instIdArr = res1.map(inst => inst.institutionId);
            let today = getFormatedLocalDate(new Date());
            res2 = res2.filter(banner => {
                if (banner.location === EVENT_BANNER_LOCATION_TYPES.ALL.value) {
                    return true;
                }
                return banner.institutions.some(id => instIdArr.includes(id));
            }).map(banner => {
                banner.isPast = banner.endDate < today;
                return banner;
            }).sort((a, b) => {
                return new Date(b.updatedDate) > new Date(a.updatedDate) ? 1 : -1;
            }).sort((a, b) => {
                // 1. Assign a Priority Score
                const getScore = (b) => {
                    if (b.endDate < today) { // Past (Lowest priority)
                        return 1;
                    }
                    return 2;  // Active (Highest priority)
                };

                const scoreA = getScore(a);
                const scoreB = getScore(b);

                // 2. Sort by Score first
                if (scoreA !== scoreB) {
                    return scoreB > scoreA ? 1 : -1;
                }

                // 3. Tie-breaker: Use updatedDate (Newest first)
                if (b.startDate !== a.startDate) {
                    return b.startDate > a.startDate ? 1 : -1;
                } else {
                    return 0;
                }
            });
            setRawData(res2);
            filterData(res2);
        }).finally(() => setIsLoading(false));
    }


    const loadInst = () => {
        return loadInstitutions().then(institutions => {
            institutions = institutions
                .filter(inst => inst.code !== YUJA_INST_CODE)
                .filter(inst => !!inst.shortName)
                .filter(inst => checkInstAccess(inst))
                .sort((instA, instB) => {
                    const {updateTime: updateTimeA=""} = instA;
                    const {updateTime: updateTimeB=""} = instB;
                    if (updateTimeA > updateTimeB) {
                        return -1;
                    } else if (updateTimeA < updateTimeB) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

            return institutions;
        });

    };

    const onBack = () => {
        setView(EVENT_BANNER_PAGE_VIEW_TYPES.LIST);
    }


    const formatBannerDate = (dateStr) => {
        if (!dateStr) {
            return "";
        }
        // Use 'T00:00:00' to ensure local timezone interpretation
        const date = new Date(dateStr + 'T00:00:00');

        return new Intl.DateTimeFormat('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
        }).format(date);
    };

    const onCreate =() => {
        let now = new Date();
        setSelectedBannerEvent({
            location: EVENT_BANNER_LOCATION_TYPES.ALL.value,
            roles:[ALL_ROLES],
            button: "Register Now",
            institutions: [],
            startDate: getFormatedLocalDate(now),
            endDate: getFormatedLocalDate(now),
        });
        setView(EVENT_BANNER_PAGE_VIEW_TYPES.CREATE);
    }

    const onEdit =(banner) => {
        setSelectedBannerEvent(banner);
        setView(EVENT_BANNER_PAGE_VIEW_TYPES.EDIT);
    }

    const onDelete =(banner) => {
        const {id} = banner;
        deleteEventBanner(id).then(res => {
            if (res) {
                loadData();
            }
        });

    }


    if (isLoading) {
        return (
            <div className={`${classes.parent} ${classes.column}`}>
                <div
                    className={`${classes.card} ${classes.column}`}
                    style={{flex: 1, minHeight: 350, overflowY: "auto", gap: 15}}
                >
                    <div className={`${classes.card} ${classes.row} ${classes.titleCard}`}>
                        <div style={{flex: 1}}>
                            <div className={classes.titleText}>
                                Events Banner
                            </div>
                            <div className={classes.descriptionText}>
                                Create event banners to inform clients about upcoming events and webinars.
                            </div>
                        </div>
                        <Skeleton borderRadius={4} height={35} inline={true} width={75}/>
                    </div>

                    <div className={`${classes.card} ${classes.column}`} style={{flex: 1}}>
                        <div className={classes.row} style={{width: "100%", gap: 10, marginBottom: 20}}>
                            <Skeleton borderRadius={4} height={35} inline={true} width={35}/>
                            <div style={{flex: 1}}>
                                <Skeleton borderRadius={4} height={40} inline={true} width={"100%"}/>
                            </div>
                        </div>

                        <div className={classes.column} style={{width: "100%", gap: 10, padding: "10px 0"}}>
                            <div style={{width: "100%"}}>
                                <Skeleton borderRadius={4} height={100} inline={true} width={"100%"}/>
                            </div>

                            <div style={{width: "100%"}}>
                                <Skeleton borderRadius={4} height={100} inline={true} width={"100%"}/>
                            </div>

                            <div style={{width: "100%"}}>
                                <Skeleton borderRadius={4} height={100} inline={true} width={"100%"}/>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        );
    }

    if (view === EVENT_BANNER_PAGE_VIEW_TYPES.CREATE
        || view === EVENT_BANNER_PAGE_VIEW_TYPES.EDIT
        || view === EVENT_BANNER_PAGE_VIEW_TYPES.PREVIEW
    ) {
        return (
            <EventBannerDetail
                setFilter={setFilter}
                selectedBannerEvent={selectedBannerEvent}
                onBack={onBack}
                view={view}
                setView={setView}
                institutions={institutions}
            />
        );
    }

    return (
        <div className={`${classes.parent} ${classes.column}`}>
            <div
                className={`${classes.card} ${classes.column}`}
                style={{flex: 1, minHeight: 350, overflowY: "auto", gap: 15, position: "relative"}}
            >
                <div className={`${classes.card} ${classes.row} ${classes.titleCard}`}>
                    <div style={{flex: 1}}>
                        <div className={classes.titleText}>
                            Events Banner
                        </div>
                        <div className={classes.descriptionText}>
                            Create event banners to inform clients about upcoming events and webinars.
                        </div>
                    </div>
                    <YuJaButton size={"medium"} onClick={onCreate}>{"Create Banner"}</YuJaButton>
                </div>

                <div className={`${classes.card} ${classes.column}`}>
                    <EventBannerSearchForm handleSubmit={handleSubmit} filter={filter}/>

                    {!filteredData.length &&
                        <div className={classes.emptySection}>
                            <div style={{flex: 1, minHeight: 0}}/>
                            <NO_BANNER/>

                            <div className={classes.emptyText}>
                                <h3 className={classes.emptyTitle}>
                                    {isFilterEmpty ? "No Upcoming Banners" : "No Matching Results"}
                                </h3>
                                <p className={classes.emptyDesc}>
                                    {isFilterEmpty
                                        ? "There are no upcoming event banners. Try adjusting the date filter to view banners for past events."
                                        : "Try adjusting the filter or broadening your search criteria to find what you are looking for."
                                    }
                                </p>
                            </div>

                            {isFilterEmpty &&
                                <YuJaButton size={"medium"} onClick={onCreate}>{"Create Banner"}</YuJaButton>
                            }
                            <div style={{flex: 1, minHeight: 0}}/>
                        </div>
                    }

                    {!!filteredData.length &&
                        <>

                            <ul className={classes.bannerList}>
                                {paginatedData.map((banner, idx) =>
                                    <li key={idx} className={classes.bannerCard}>
                                        <div className={classes.row}>
                                            <div className={classes.column} style={{gap: 6}}>
                                                <div className={classes.column} style={{gap: 3}}>
                                                    {banner.isPast &&
                                                        <div className={classes.pastBadge}>
                                                            <CLOCK_GRAY/> Past
                                                        </div>
                                                    }
                                                    <h2 className={classes.bannerCardTitle}>
                                                        {banner.description}
                                                    </h2>
                                                </div>

                                                <div className={classes.bannerCardDescription}>
                                                <CLOCK style={{flexShrink: 0}}/>
                                                   <span>
                                                       Banner Scheduled: {formatBannerDate(banner.startDate)}
                                                       &nbsp;to&nbsp;
                                                       {formatBannerDate(banner.endDate)}
                                                   </span>
                                                </div>
                                            </div>
                                            <div style={{flex: 1}}/>
                                            <YuJaKebabMenuNew triggerAriaLabel={`Actions for ${banner.description}`}>
                                                <YuJaKebabMenuNew.Menu>
                                                    <YuJaKebabMenuNew.Item onClick={() => onEdit(banner)}>
                                                        {EDIT_TEXT}
                                                    </YuJaKebabMenuNew.Item>
                                                    <YuJaKebabMenuNew.Item
                                                        onClick={() => {
                                                            setPreSelectBanner(banner);
                                                            setIsConfirmationOpened(true);
                                                        }}
                                                    >
                                                        {DELETE_TEXT}
                                                    </YuJaKebabMenuNew.Item>
                                                </YuJaKebabMenuNew.Menu>
                                            </YuJaKebabMenuNew>
                                        </div>

                                    </li>
                                )}
                            </ul>

                            {pageCount > 1 &&
                                <NormalPagination
                                    pageCount={pageCount}
                                    pageIndex={pageIndex}
                                    pageOptions={pageOptions()}
                                    canPreviousPage={canPreviousPage()}
                                    canNextPage={canNextPage()}
                                    previousPage={previousPage}
                                    nextPage={nextPage}
                                    gotoPage={gotoPage}
                                    paddingTop="0px"
                                />
                            }
                        </>
                    }


                    <YuJaDialog
                        open={isConfirmationOpened}
                        setOpen={setIsConfirmationOpened}
                        title={"Delete Event Banner"}
                        closeText={"Cancel"}
                        deleteText={"Delete"}
                        centerAligned={false}
                        onDelete={() => {
                            onDelete(preSelectBanner);
                        }}
                    >
                        <p style={{color: "#000000DE", marginBottom: 0}}>
                            {`Are you sure you want to delete the event banner "`}<strong>{preSelectBanner.description}</strong>{`"?`}
                        </p>
                    </YuJaDialog>


                </div>


            </div>
        </div>
    );
}